import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = ["aria-label", "aria-pressed"]
const _hoisted_3 = ["aria-label", "aria-pressed"]

import { useI18n } from 'vue-i18n';
import { persistLocale } from '@/utils/locale';
import { setDocumentLocale } from '@/i18n';
import type { LocaleCode } from '@/data/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'LocaleToggle',
  setup(__props) {

const { locale } = useI18n();

function setLocale(code: LocaleCode) {
  locale.value = code;
  persistLocale(code);
  setDocumentLocale(code);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "locale-toggle",
    role: "group",
    "aria-label": _ctx.$t('locale.switchToEn')
  }, [
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass(["locale-btn", { active: _unref(locale) === 'pt-BR' }]),
      "aria-label": _ctx.$t('locale.switchToPt'),
      "aria-pressed": _unref(locale) === 'pt-BR',
      onClick: _cache[0] || (_cache[0] = ($event: any) => (setLocale('pt-BR')))
    }, [...(_cache[2] || (_cache[2] = [
      _createElementVNode("img", {
        class: "flag-icon",
        src: "/images/flags/pt-br.svg",
        width: "24",
        height: "16",
        alt: ""
      }, null, -1)
    ]))], 10, _hoisted_2),
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass(["locale-btn", { active: _unref(locale) === 'en' }]),
      "aria-label": _ctx.$t('locale.switchToEn'),
      "aria-pressed": _unref(locale) === 'en',
      onClick: _cache[1] || (_cache[1] = ($event: any) => (setLocale('en')))
    }, [...(_cache[3] || (_cache[3] = [
      _createElementVNode("img", {
        class: "flag-icon",
        src: "/images/flags/en.svg",
        width: "24",
        height: "16",
        alt: ""
      }, null, -1)
    ]))], 10, _hoisted_3)
  ], 8, _hoisted_1))
}
}

})